import { render, staticRenderFns } from "./purchaseCompleted.vue?vue&type=template&id=b369d93a&scoped=true"
import script from "./purchaseCompleted.vue?vue&type=script&lang=js"
export * from "./purchaseCompleted.vue?vue&type=script&lang=js"
import style0 from "./purchaseCompleted.vue?vue&type=style&index=0&id=b369d93a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b369d93a",
  null
  
)

export default component.exports